const state = {
  information:{}, //mainaccount
  organisationsWithoutCollaborator: [],
  selectedAccount: {}, //current account 
  refreshOrganisationList: false,
  sitePermissions: [],
  refreshProfileAndPermissions: false,
  expiredSubscription: false
};

const mutations = {
  SET_USER_INFORMATION(state, payload){
    state.information = payload
  },
  SET_ORGANISATIONS_WITHOUT_COLLABORATOR (state, payload) {
      state.organisationsWithoutCollaborator = payload
  },
  SET_SELECTED_ACCOUNT (state, payload) {
    state.selectedAccount = payload
  },
  SET_REFRESH_ORGANISATION_LIST (state, payload) {
    state.refreshOrganisationList = payload
  },
  SET_SITE_PERMISSIONS (state, payload) {
    state.sitePermissions = payload
  },
  CLEAR_SITE_PERMISSIONS (state) {
    state.sitePermissions = []
  },
  SET_REFRESH_PROFILE_AND_PERMISSIONS(state, payload){
    state.refreshProfileAndPermissions = payload
  },
  SET_SUBSCRIPTION_STATUS(state, payload) {
    state.expiredSubscription = payload
  }
};

const actions = {
  setUserInformationToStore({commit}, payload){
    commit('SET_USER_INFORMATION', {id: payload._id, ...payload})
  },
  setOrganisationsWithoutCollaborator ({commit}, payload) {
      commit('SET_ORGANISATIONS_WITHOUT_COLLABORATOR', payload)
  },
  setSelectedAccount ({commit}, payload) {
    commit('SET_SELECTED_ACCOUNT', payload)
  },
  setRefreshOrganisationList ({commit}, payload) {
    commit('SET_REFRESH_ORGANISATION_LIST', payload)
  },
  setSitePermissions( {commit}, payload ) {
    commit('SET_SITE_PERMISSIONS', payload)
  },
  clearSitePermissions( {commit} ) {
    commit('CLEAR_SITE_PERMISSIONS')
  },
  async setRefreshUserProfileAndPermissions ({commit}, payload) {
    //
    commit('SET_REFRESH_PROFILE_AND_PERMISSIONS', payload)
  },
  setExpiredSubscription( {commit}, payload) {
    commit('SET_SUBSCRIPTION_STATUS', payload)
  }
  
};

const getters={
  getUserInformation(state){
    return state.information;
  },
  getOrganisationWithoutCollaborator (state) {
    return state.organisationsWithoutCollaborator
  },
  getSelectedAccount (state) {
    return state.selectedAccount
  },
  getRefreshOrganisationList (state) {
    return state.refreshOrganisationList
  },
  organisationActive (state) {
    return state.selectedAccount.type === 'ORGANISATION'
  },
  hasPermission: (state, getters) => payload => {
    if(!getters.organisationActive) {
      return true;
    }
    else return state.sitePermissions.includes(payload)
  },
  getRefreshUserProfileAndPermissions (state) {
    return state.refreshProfileAndPermissions
  },
  userSubscriptionExpired (state) {
    return state.expiredSubscription
  }
};
export default {
  state,
  mutations,
  actions,
  getters
}
